import { StarFilled } from '@ant-design/icons';
import React from 'react';

function RatingStars({ star }) {
    const fullStars = Math.floor(star); // Get full stars count
    const hasHalfStar = star % 1 !== 0; // Check if there's a half star
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0); // Remaining empty stars

    const stars = [];

    // Add full stars
    for (let i = 0; i < fullStars; i++) {
        stars.push(
            <StarFilled key={i} style={{ color: '#FFA931', marginRight: 2, fontSize: 14 }} />
        );
    }

    // Add half star (if any)
    if (hasHalfStar) {
        stars.push(
            <span key="half" style={{ position: 'relative', display: 'inline-block', marginRight: 2, verticalAlign: 'middle' }}>
                <StarFilled style={{ color: '#AEAEAE', fontSize: 14 }} />
                <span style={{ position: 'absolute', left: 0, top: 0, width: `${(star % 1) * 100}%`, overflow: 'hidden' }}>
                    <StarFilled style={{ color: '#FFA931', fontSize: 14 }} />
                </span>
            </span>
        );
    }

    // Add empty stars
    for (let i = 0; i < emptyStars; i++) {
        stars.push(
            <StarFilled key={`empty-${i}`} style={{ color: '#AEAEAE', marginRight: 2, fontSize: 14 }} />
        );
    }

    return (
        <div style={{display:'flex'}}>
            <div style={{ color: "#FFA931", fontSize: 14, margin: "0px 0px 0px 2px", fontWeight: 700, marginRight: 6 }}>{star ? star : 0}</div>
            <div style={{ display: "flex", alignItems: 'center' }}>
                {stars}
            </div>
        </div>

    );
}


// const RatingStars = ({ star }) => {
//     console.log('kkkkkk', star, typeof star);
//     return (
//         <Rate 
//             disabled 
//             value={Number(star) || 0}  // Ensure it's a valid number
//             allowHalf 
//             style={{ color: '#FFA931', marginLeft: 2, fontSize: 13 }} 
//         />
//     );
// };





export default RatingStars
